import React from "react";

const HORIZ = "/logo-horizontal.png";
const HORIZ_LIGHT = "/logo-horizontal-light.png";
const MARK = "/logo-mark.png";

export const ShieldMark = ({ className = "" }) => (
  <img src={MARK} alt="Iron Shield mark" className={className} />
);

export const Logo = ({ className = "", variant = "horizontal", light = false }) => {
  if (variant === "mark") {
    return <img src={MARK} alt="Iron Shield" className={className || "h-10 w-auto"} />;
  }
  return (
    <img
      src={light ? HORIZ_LIGHT : HORIZ}
      alt="Iron Shield Veterans Reset Center"
      className={className || "h-11 md:h-14 w-auto"}
    />
  );
};

export default Logo;
